/**
 *
 * @param {string} querySize Fill in the blank to complete the custom property '--js-{{ querySize }}'.
 * Options maintained within js-breakpoints.css
 * @returns complete custom property to set breakpoint changes.
 */
function getMediaQuery(querySize) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    `--media-${querySize}`
  );

  if (!value) {
    console.warn("Invalid querySize passed to getMediaQuery");
    return false;
  }

  return value;
}

/**
 *
 * @param {string} querySize Fill in the blank to complete the custom property '--js-{{ querySize }}'.
 * Options maintained within js-breakpoints.css
 * @returns {boolean} Whether the media query size applies to the device.
 */
function checkMediaQuery(querySize) {
  const mediaQuery = getMediaQuery(querySize);

  return window.matchMedia(mediaQuery).matches;
}

export { getMediaQuery, checkMediaQuery };
